import { Device, WorkOrderDetailsDeviceData } from '@zspace/types';

export function getDeviceName(device: Device | WorkOrderDetailsDeviceData) {
  return device.name || device.serialNumber?.number || device.defaultName;
}
